import { useState } from 'react';

import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'codemirror/mode/javascript/javascript';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DoneIcon from '@mui/icons-material/Done';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { UnControlled as CodeMirror } from 'react-codemirror2';
import { useTranslation } from 'react-i18next';

import Text from '../../elements/text/Text';

const StyledWrapper = styled('div')({
  position: 'absolute',
  top: 0,
  zIndex: 4,
  right: 20,
});
const StyledCard = styled(Card)({
  backgroundColor: '#263238',
  color: '#EEFFFF',
  maxHeight: 350,
  overflowY: 'auto',
});
const StyledButtonRadius = styled(Button)(({ theme }) => ({
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  color: 'rgba(0, 0, 0, 0.87)',
  backgroundColor: theme.palette.grey[200], // '#eeeeee' is grey[200]
}));

const CopyBox = ({ content, isJson }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    setCopied(true);
  };

  const button = (
    <StyledButtonRadius
      size="small"
      // color="dark"
      startIcon={copied ? <DoneIcon /> : <AssignmentIcon />}
      onClick={handleCopy}
      aria-label="copy"
    >
      {copied ? t('copied', { ns: 'tooltips' }) : t('copy', { ns: 'tooltips' })}
    </StyledButtonRadius>
  );

  return (
    <Box position="relative">
      <>
        <StyledWrapper>{button}</StyledWrapper>
        {isJson ? (
          <CodeMirror
            value={content}
            options={{
              mode: 'application/json',
              theme: 'material',
              lineNumbers: true,
              lineWrapping: true,
              readOnly: 'nocursor',
            }}
          />
        ) : (
          <StyledCard variant="outlined">
            <Box
              p={1}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Text style={{ wordBreak: 'break-all' }}>{content}</Text>
            </Box>
          </StyledCard>
        )}
      </>
    </Box>
  );
};

CopyBox.propTypes = {
  content: PropTypes.string,
  isJson: PropTypes.bool,
};

export default CopyBox;
